import React from "react";
import { stats } from "../content/landingContent";
import { useCountUp } from "../hooks/useCountUp";
import { useContentJson } from "../lib/useContent";

const StatItem: React.FC<{ item: (typeof stats.items)[number] }> = ({ item }) => {
  const { ref, value } = useCountUp({ from: item.from, to: item.to, duration: 2000 });
  return (
    <div ref={ref} data-testid={`stat-item-${item.label.replace(/\s+/g, "-")}`} className="text-center">
      <div className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tabular-nums">
        {item.prefix}
        {value.toLocaleString("es-HN")}
        {item.suffix}
      </div>
      <p className="mt-3 text-sm sm:text-base text-white/85 font-medium">{item.label}</p>
    </div>
  );
};

export const StatsSection: React.FC = () => {
  const items = useContentJson("stats.itemsJson", stats.items);
  return (
    <section
      data-testid="stats-section"
      className="relative bg-motor-red py-16 sm:py-20"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-6">
        {items.map((item) => (
          <StatItem key={item.label} item={item} />
        ))}
      </div>
    </section>
  );
};
